import { render, staticRenderFns } from "./ForgotPasswordForm.vue?vue&type=template&id=65cf2cda&scoped=true"
import script from "./ForgotPasswordForm.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordForm.vue?vue&type=script&lang=js"
import style0 from "./ForgotPasswordForm.vue?vue&type=style&index=0&id=65cf2cda&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65cf2cda",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/home/bazzite/Work/awardapplication/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65cf2cda')) {
      api.createRecord('65cf2cda', component.options)
    } else {
      api.reload('65cf2cda', component.options)
    }
    module.hot.accept("./ForgotPasswordForm.vue?vue&type=template&id=65cf2cda&scoped=true", function () {
      api.rerender('65cf2cda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/modules/auth/components/ForgotPasswordForm.vue"
export default component.exports